import { render } from "./PlatformsChart.vue?vue&type=template&id=11668f8c&scoped=true"
import script from "./PlatformsChart.vue?vue&type=script&lang=js"
export * from "./PlatformsChart.vue?vue&type=script&lang=js"

import "./PlatformsChart.vue?vue&type=style&index=0&id=11668f8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11668f8c"]])

export default __exports__